import React from "react";
// import { routes } from "../../routes/pageRoutes";
import { PlusIcon } from "../../assets/icons";
import CommonButton from "../../components/commonButton";
import { usePermission } from "../../hooks/usePermission";
import { TableSearch } from "../../components/form/Fields";

const MODULE = "map_jantri";

const NpaAddImpExprtBtn = ({
  searchQuery,
  setSearchQuery,
  onAddMapClick,
  title
}) => {


  const { hasPermission } = usePermission();

  return (
    <>
      <div className="p-4 d-flex align-items-center justify-content-between flex-wrap gap-3">

        <TableSearch value={searchQuery} // Use the immediate typing state
          placeholder="Search"
          onChange={(e) => {
            // Update the searchQuery state with every keystroke.
            // The debounce useEffect will handle updating the filterValues.
            setSearchQuery(e.target.value);
          }} />


        {hasPermission(MODULE, "create") && (
          <CommonButton
            icon={<PlusIcon />}
            className="ms-auto"
            variant="primary"
            title={`Add ${title}`}
            onClick={(e) => {
              e.stopPropagation();
              onAddMapClick();
            }}
          />
        )}
        {/* <CommonButton
            icon={<span><img src={ExportImportImg} alt="import" /></span>}
            className="btn-primary-light me-2"
            title="Export"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleExportNpaProperties();
            }}
          /> */}
        {/* <CommonButton
            icon={<span><img src={AddPropertyImg} alt="import" /></span>}
            className="btn-primary"
            title="Add Property"
            onClick={(e) => {
              navigate(routes.addBrokerProperty);
            }}
          /> */}
      </div>
    </>
  );
};

export default NpaAddImpExprtBtn;
